import { render } from "./Dashboard_Calendar_View.vue?vue&type=template&id=2b98e94c"
import script from "./Dashboard_Calendar_View.vue?vue&type=script&lang=js"
export * from "./Dashboard_Calendar_View.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__